export const communityList = [
  {
    Id: 1,
    Name: 'Hindu-Brahmin-Anavil',
  },
  {
    Id: 2,
    Name: 'Hindu-Maratha',
  },
  {
    Id: 3,
    Name: 'Hindu-Rajput',
  },
  {
    Id: 4,
    Name: 'Hindu-Brahmin-Other',
  },
  {
    Id: 5,
    Name: 'Hindu-Yadav',
  },
  {
    Id: 6,
    Name: 'Hindu-Agarwal',
  },
  {
    Id: 7,
    Name: 'Hindu-Baniya',
  },
  {
    Id: 8,
    Name: 'Sikh-Jat',
  },
  {
    Id: 9,
    Name: 'Hindu-Kayastha',
  },
  {
    Id: 11,
    Name: 'Buddhist-Buddhist',
  },
  {
    Id: 12,
    Name: 'Hindu-96K Kokanastha',
  },
  {
    Id: 13,
    Name: 'Hindu-Adi Andhra',
  },
  {
    Id: 14,
    Name: 'Hindu-Adi Dharmi',
  },
  {
    Id: 15,
    Name: 'Hindu-Adi Dravida',
  },
  {
    Id: 16,
    Name: 'Hindu-Adi Karnataka',
  },
  {
    Id: 17,
    Name: 'Hindu-Agarwal',
  },
  {
    Id: 18,
    Name: 'Hindu-Agnikula Kshatriya',
  },
  {
    Id: 19,
    Name: 'Hindu-Agri',
  },
  {
    Id: 20,
    Name: 'Hindu-Ahir',
  },
  {
    Id: 21,
    Name: 'Hindu-Ahom',
  },
  {
    Id: 22,
    Name: 'Hindu-Arekatica',
  },
  {
    Id: 23,
    Name: 'Hindu-Arora',
  },
  {
    Id: 24,
    Name: 'Hindu-Arya Vysya',
  },
  {
    Id: 25,
    Name: 'Hindu-Aryasamaj',
  },
  {
    Id: 26,
    Name: 'Hindu-Baghel/Pal/Gaderiya',
  },
  {
    Id: 27,
    Name: 'Hindu-Bahi',
  },
  {
    Id: 28,
    Name: 'Hindu-Baidya',
  },
  {
    Id: 29,
    Name: 'Hindu-Baishnab',
  },
  {
    Id: 30,
    Name: 'Hindu-Balija',
  },
  {
    Id: 31,
    Name: 'Hindu-Banik',
  },
  {
    Id: 32,
    Name: 'Hindu-Baniya',
  },
  {
    Id: 33,
    Name: 'Hindu-Barai',
  },
  {
    Id: 34,
    Name: 'Hindu-Bari',
  },
  {
    Id: 35,
    Name: 'Hindu-Barujibi',
  },
  {
    Id: 36,
    Name: 'Hindu-Besta',
  },
  {
    Id: 37,
    Name: 'Hindu-Bhandari',
  },
  {
    Id: 38,
    Name: 'Hindu-Bhatia',
  },
  {
    Id: 39,
    Name: 'Hindu-Bhavsar',
  },
  {
    Id: 40,
    Name: 'Hindu-Bhovi',
  },
  {
    Id: 41,
    Name: 'Hindu-Bhumihar',
  },
  {
    Id: 42,
    Name: 'Hindu-Billava',
  },
  {
    Id: 43,
    Name: 'Hindu-Boya/Nayak/Naik',
  },
  {
    Id: 44,
    Name: 'Hindu-Boyer',
  },
  {
    Id: 45,
    Name: 'Hindu-Brahmin-Devruke',
  },
  {
    Id: 46,
    Name: 'Hindu-Brahmbatt',
  },
  {
    Id: 47,
    Name: 'Hindu-Brahmin-Anavil',
  },
  {
    Id: 48,
    Name: 'Hindu-Brahmin-Audichya',
  },
  {
    Id: 49,
    Name: 'Hindu-Brahmin-Barendra',
  },
  {
    Id: 50,
    Name: 'Hindu-Brahmin-Bhatt',
  },
  {
    Id: 51,
    Name: 'Hindu-Brahmin-Bhumihar',
  },
  {
    Id: 52,
    Name: 'Hindu-Brahmin-Brahmbhatt',
  },
  {
    Id: 53,
    Name: 'Hindu-Brahmin-Dadhich/Dadheech',
  },
  {
    Id: 54,
    Name: 'Hindu-Brahmin-Daivadnya',
  },
  {
    Id: 55,
    Name: 'Hindu-Brahmin-Danua',
  },
  {
    Id: 56,
    Name: 'Hindu-Brahmin-Deshastha',
  },
  {
    Id: 57,
    Name: 'Hindu-Brahmin-Dhiman',
  },
  {
    Id: 58,
    Name: 'Hindu-Brahmin-Dravida',
  },
  {
    Id: 59,
    Name: 'Hindu-Brahmin-Goswami',
  },
  {
    Id: 60,
    Name: 'Hindu-Brahmin-Gour',
  },
  {
    Id: 61,
    Name: 'Hindu-Brahmin-Gowd Saraswat',
  },
  {
    Id: 62,
    Name: 'Hindu-Brahmin-Gujar Gour',
  },
  {
    Id: 63,
    Name: 'Hindu-Brahmin-Gurukkal',
  },
  {
    Id: 64,
    Name: 'Hindu-Brahmin-Jangid',
  },
  {
    Id: 65,
    Name: 'Hindu-Brahmin-Jhadua',
  },
  {
    Id: 66,
    Name: 'Hindu-Brahmin-Jhijhotiya',
  },
  {
    Id: 67,
    Name: 'Hindu-Brahmin-Jyotish',
  },
  {
    Id: 68,
    Name: 'Hindu-Brahmin-Kanyakubja',
  },
  {
    Id: 69,
    Name: 'Hindu-Brahmin-Karhade',
  },
  {
    Id: 70,
    Name: 'Hindu-Brahmin-Kashmiri Pandit',
  },
  {
    Id: 71,
    Name: 'Hindu-Brahmin-Kota',
  },
  {
    Id: 72,
    Name: 'Hindu-Brahmin-Kulin',
  },
  {
    Id: 73,
    Name: 'Hindu-Brahmin-Kumaoni',
  },
  {
    Id: 74,
    Name: 'Hindu-Brahmin-Madhwa',
  },
  {
    Id: 75,
    Name: 'Hindu-Brahmin-Maithili',
  },
  {
    Id: 76,
    Name: 'Hindu-Brahmin-Modh',
  },
  {
    Id: 77,
    Name: 'Hindu-Brahmin-Mohyal',
  },
  {
    Id: 78,
    Name: 'Hindu-Brahmin-Nagar',
  },
  {
    Id: 79,
    Name: 'Hindu-Brahmin-Nayak',
  },
  {
    Id: 80,
    Name: 'Hindu-Brahmin-Niyogi',
  },
  {
    Id: 81,
    Name: 'Hindu-Brahmin-Other',
  },
  {
    Id: 82,
    Name: 'Hindu-Brahmin-Paliwal',
  },
  {
    Id: 83,
    Name: 'Hindu-Brahmin-Panda',
  },
  {
    Id: 84,
    Name: 'Hindu-Brahmin-Pareek',
  },
  {
    Id: 85,
    Name: 'Hindu-Brahmin-Pushkarna',
  },
  {
    Id: 86,
    Name: 'Hindu-Brahmin-Rudraj',
  },
  {
    Id: 87,
    Name: 'Hindu-Brahmin-Sakaldwipi',
  },
  {
    Id: 88,
    Name: 'Hindu-Brahmin-Sanadya',
  },
  {
    Id: 89,
    Name: 'Hindu-Brahmin-Sanketi',
  },
  {
    Id: 90,
    Name: 'Hindu-Brahmin-Saraswat',
  },
  {
    Id: 91,
    Name: 'Hindu-Brahmin-Sarua',
  },
  {
    Id: 92,
    Name: 'Hindu-Brahmin-Saryuparin',
  },
  {
    Id: 93,
    Name: 'Hindu-Brahmin-Shrimali',
  },
  {
    Id: 94,
    Name: 'Hindu-Brahmin-Smartha',
  },
  {
    Id: 95,
    Name: 'Hindu-Brahmin-Sri Vaishnava',
  },
  {
    Id: 96,
    Name: 'Hindu-Brahmin-Tyagi',
  },
  {
    Id: 97,
    Name: 'Hindu-Brahmin-Vaidiki',
  },
  {
    Id: 98,
    Name: 'Hindu-Brahmin-Vaikhanasa',
  },
  {
    Id: 99,
    Name: 'Hindu-Brahmin-Viswabrahmin',
  },
  {
    Id: 100,
    Name: 'Hindu-Brahmin-Vyas',
  },
  {
    Id: 101,
    Name: 'Hindu-Brahmo',
  },
  {
    Id: 102,
    Name: 'Hindu-Buddar',
  },
  {
    Id: 103,
    Name: 'Hindu-CKP',
  },
  {
    Id: 104,
    Name: 'Hindu-Chain',
  },
  {
    Id: 105,
    Name: 'Hindu-Chambhar',
  },
  {
    Id: 106,
    Name: 'Hindu-Chandravanshi Kahar',
  },
  {
    Id: 107,
    Name: 'Hindu-Chasa',
  },
  {
    Id: 108,
    Name: 'Hindu-Chaudary',
  },
  {
    Id: 109,
    Name: 'Hindu-Chaurasia',
  },
  {
    Id: 110,
    Name: 'Hindu-Cheramar',
  },
  {
    Id: 111,
    Name: 'Hindu-Chettiar',
  },
  {
    Id: 112,
    Name: 'Hindu-Chhetri',
  },
  {
    Id: 113,
    Name: 'Hindu-Devadiga',
  },
  {
    Id: 114,
    Name: 'Hindu-Devanga',
  },
  {
    Id: 115,
    Name: 'Hindu-Devar/Thevar/Mukkulathor',
  },
  {
    Id: 116,
    Name: 'Hindu-Dhangar',
  },
  {
    Id: 117,
    Name: 'Hindu-Dheevara',
  },
  {
    Id: 118,
    Name: 'Hindu-Dhiman',
  },
  {
    Id: 119,
    Name: 'Hindu-Dhoba',
  },
  {
    Id: 120,
    Name: 'Hindu-Digambar',
  },
  {
    Id: 121,
    Name: 'Hindu-Dusadh',
  },
  {
    Id: 122,
    Name: 'Hindu-Ganiga',
  },
  {
    Id: 123,
    Name: 'Hindu-Gavali',
  },
  {
    Id: 124,
    Name: 'Hindu-Gavara',
  },
  {
    Id: 125,
    Name: 'Hindu-Ghumar',
  },
  {
    Id: 126,
    Name: 'Hindu-Goala',
  },
  {
    Id: 127,
    Name: 'Hindu-Goswami',
  },
  {
    Id: 128,
    Name: 'Hindu-Goud',
  },
  {
    Id: 129,
    Name: 'Hindu-Gounder',
  },
  {
    Id: 130,
    Name: 'Hindu-Gowda',
  },
  {
    Id: 131,
    Name: 'Hindu-Gudia',
  },
  {
    Id: 132,
    Name: 'Hindu-Gujjar',
  },
  {
    Id: 133,
    Name: 'Hindu-Gupta',
  },
  {
    Id: 134,
    Name: 'Hindu-Guptan',
  },
  {
    Id: 135,
    Name: 'Hindu-Gurjar',
  },
  {
    Id: 136,
    Name: 'Hindu-Halwai',
  },
  {
    Id: 137,
    Name: 'Hindu-Helava',
  },
  {
    Id: 138,
    Name: 'Hindu-Other',
  },
  {
    Id: 139,
    Name: 'Hindu-Intercaste',
  },
  {
    Id: 140,
    Name: 'Hindu-Jaiswal',
  },
  {
    Id: 141,
    Name: 'Hindu-Jandra',
  },
  {
    Id: 142,
    Name: 'Hindu-Jangam',
  },
  {
    Id: 143,
    Name: 'Hindu-Jat',
  },
  {
    Id: 144,
    Name: 'Hindu-Jatav',
  },
  {
    Id: 145,
    Name: 'Hindu-Jetty Malla',
  },
  {
    Id: 146,
    Name: 'Hindu-Kachara',
  },
  {
    Id: 147,
    Name: 'Hindu-Kaibarta',
  },
  {
    Id: 148,
    Name: 'Hindu-Kalar',
  },
  {
    Id: 149,
    Name: 'Hindu-Kalwar',
  },
  {
    Id: 150,
    Name: 'Hindu-Kamboj',
  },
  {
    Id: 151,
    Name: 'Hindu-Kamma',
  },
  {
    Id: 152,
    Name: 'Hindu-Kansari',
  },
  {
    Id: 153,
    Name: 'Hindu-Kanu',
  },
  {
    Id: 154,
    Name: 'Hindu-Kapu',
  },
  {
    Id: 155,
    Name: 'Hindu-Karana',
  },
  {
    Id: 156,
    Name: 'Hindu-Karmakar',
  },
  {
    Id: 157,
    Name: 'Hindu-Kasar',
  },
  {
    Id: 158,
    Name: 'Hindu-Kashyap',
  },
  {
    Id: 159,
    Name: 'Hindu-Kayastha',
  },
  {
    Id: 160,
    Name: 'Hindu-Khandayat',
  },
  {
    Id: 161,
    Name: 'Hindu-Khandelwal',
  },
  {
    Id: 162,
    Name: 'Hindu-Kharwar',
  },
  {
    Id: 163,
    Name: 'Hindu-Khatik',
  },
  {
    Id: 164,
    Name: 'Hindu-Khatri',
  },
  {
    Id: 165,
    Name: 'Hindu-Koli',
  },
  {
    Id: 166,
    Name: 'Hindu-Kongu Vellala Gounder',
  },
  {
    Id: 167,
    Name: 'Hindu-Konkani',
  },
  {
    Id: 168,
    Name: 'Hindu-Kori',
  },
  {
    Id: 169,
    Name: 'Hindu-Koshti',
  },
  {
    Id: 170,
    Name: 'Hindu-Kshatriya',
  },
  {
    Id: 171,
    Name: 'Hindu-Kudumbi',
  },
  {
    Id: 172,
    Name: 'Hindu-Kulal',
  },
  {
    Id: 173,
    Name: 'Hindu-Kumbhakar',
  },
  {
    Id: 174,
    Name: 'Hindu-Kumhar/Kumbhar',
  },
  {
    Id: 175,
    Name: 'Hindu-Kunbi',
  },
  {
    Id: 176,
    Name: 'Hindu-Kurmi',
  },
  {
    Id: 177,
    Name: 'Hindu-Kuruba',
  },
  {
    Id: 178,
    Name: 'Hindu-Kushwaha',
  },
  {
    Id: 179,
    Name: 'Hindu-Kutchi',
  },
  {
    Id: 180,
    Name: 'Hindu-Ladva',
  },
  {
    Id: 181,
    Name: 'Hindu-Lambadi',
  },
  {
    Id: 182,
    Name: 'Hindu-Leva Patil',
  },
  {
    Id: 183,
    Name: 'Hindu-Leva Patidar',
  },
  {
    Id: 184,
    Name: 'Hindu-Lingayath',
  },
  {
    Id: 185,
    Name: 'Hindu-Lohana',
  },
  {
    Id: 186,
    Name: 'Hindu-Madiga',
  },
  {
    Id: 187,
    Name: 'Hindu-Mahajan',
  },
  {
    Id: 188,
    Name: 'Hindu-Mahar',
  },
  {
    Id: 189,
    Name: 'Hindu-Mahendra',
  },
  {
    Id: 190,
    Name: 'Hindu-Maheshwari',
  },
  {
    Id: 191,
    Name: 'Hindu-Mahisya',
  },
  {
    Id: 192,
    Name: 'Hindu-Mainpuri',
  },
  {
    Id: 193,
    Name: 'Hindu-Mala',
  },
  {
    Id: 194,
    Name: 'Hindu-Mali',
  },
  {
    Id: 195,
    Name: 'Hindu-Mallah',
  },
  {
    Id: 196,
    Name: 'Hindu-Mallick',
  },
  {
    Id: 197,
    Name: 'Hindu-Mang',
  },
  {
    Id: 198,
    Name: 'Hindu-Maniyani',
  },
  {
    Id: 199,
    Name: 'Hindu-Mannan',
  },
  {
    Id: 200,
    Name: 'Hindu-Mapila',
  },
  {
    Id: 201,
    Name: 'Hindu-Maratha',
  },
  {
    Id: 202,
    Name: 'Hindu-Maruthuvar',
  },
  {
    Id: 203,
    Name: 'Hindu-Matang',
  },
  {
    Id: 204,
    Name: 'Hindu-Maurya',
  },
  {
    Id: 205,
    Name: 'Hindu-Meda',
  },
  {
    Id: 206,
    Name: 'Hindu-Meena',
  },
  {
    Id: 207,
    Name: 'Hindu-Meenavar',
  },
  {
    Id: 208,
    Name: 'Hindu-Mehra',
  },
  {
    Id: 209,
    Name: 'Hindu-Menon',
  },
  {
    Id: 210,
    Name: 'Hindu-Meru Darji',
  },
  {
    Id: 211,
    Name: 'Hindu-Mogaveera',
  },
  {
    Id: 212,
    Name: 'Hindu-Mudaliar',
  },
  {
    Id: 213,
    Name: 'Hindu-Mudiraj',
  },
  {
    Id: 214,
    Name: 'Hindu-Muktibodh',
  },
  {
    Id: 215,
    Name: 'Hindu-Mullu Kurumba',
  },
  {
    Id: 216,
    Name: 'Hindu-Muthuraja',
  },
  {
    Id: 217,
    Name: 'Hindu-Nadar',
  },
  {
    Id: 218,
    Name: 'Hindu-Nagaralu',
  },
  {
    Id: 219,
    Name: 'Hindu-Naicker',
  },
  {
    Id: 220,
    Name: 'Hindu-Naidu',
  },
  {
    Id: 221,
    Name: 'Hindu-Nair',
  },
  {
    Id: 222,
    Name: 'Hindu-Namosudra/Namosudri',
  },
  {
    Id: 223,
    Name: 'Hindu-Napit',
  },
  {
    Id: 224,
    Name: 'Hindu-Nayaka',
  },
  {
    Id: 225,
    Name: 'Hindu-Nayi Brahmin',
  },
  {
    Id: 226,
    Name: 'Hindu-Nepali',
  },
  {
    Id: 227,
    Name: 'Hindu-Nhavi',
  },
  {
    Id: 228,
    Name: 'Hindu-Oswal',
  },
  {
    Id: 229,
    Name: 'Hindu-Other-Other',
  },
  {
    Id: 230,
    Name: 'Hindu-Padmashali',
  },
  {
    Id: 231,
    Name: 'Hindu-Pallan/Devandra Kula Vellalan',
  },
  {
    Id: 232,
    Name: 'Hindu-Panchal',
  },
  {
    Id: 233,
    Name: 'Hindu-Pandaram',
  },
  {
    Id: 234,
    Name: 'Hindu-Panicker',
  },
  {
    Id: 235,
    Name: 'Hindu-Pannayar',
  },
  {
    Id: 236,
    Name: 'Hindu-Parkava Kulam',
  },
  {
    Id: 237,
    Name: 'Hindu-Parsi',
  },
  {
    Id: 238,
    Name: 'Hindu-Patel',
  },
  {
    Id: 239,
    Name: 'Hindu-Patnaick',
  },
  {
    Id: 240,
    Name: 'Hindu-Patra',
  },
  {
    Id: 241,
    Name: 'Hindu-Perika',
  },
  {
    Id: 242,
    Name: 'Hindu-Pillai',
  },
  {
    Id: 243,
    Name: 'Hindu-Porwal',
  },
  {
    Id: 244,
    Name: 'Hindu-Rajaka',
  },
  {
    Id: 245,
    Name: 'Hindu-Rajbhar',
  },
  {
    Id: 246,
    Name: 'Hindu-Rajbonshi',
  },
  {
    Id: 247,
    Name: 'Hindu-Rajput',
  },
  {
    Id: 248,
    Name: 'Hindu-Ramdasia',
  },
  {
    Id: 249,
    Name: 'Hindu-Ramgariah',
  },
  {
    Id: 250,
    Name: 'Hindu-Ravidasia',
  },
  {
    Id: 251,
    Name: 'Hindu-Rawat',
  },
  {
    Id: 252,
    Name: 'Hindu-Reddy',
  },
  {
    Id: 253,
    Name: 'Hindu-Sadgope',
  },
  {
    Id: 254,
    Name: 'Hindu-Saha',
  },
  {
    Id: 255,
    Name: 'Hindu-Sahu',
  },
  {
    Id: 256,
    Name: 'Hindu-Saini',
  },
  {
    Id: 257,
    Name: 'Hindu-Saliya',
  },
  {
    Id: 258,
    Name: 'Hindu-Saliyar',
  },
  {
    Id: 259,
    Name: 'Hindu-Sambava',
  },
  {
    Id: 260,
    Name: 'Hindu-Scheduled Caste',
  },
  {
    Id: 261,
    Name: 'Hindu-Senai Thalaivar',
  },
  {
    Id: 262,
    Name: 'Hindu-Settibalija',
  },
  {
    Id: 263,
    Name: 'Hindu-Shetty',
  },
  {
    Id: 264,
    Name: 'Hindu-Shimpi',
  },
  {
    Id: 265,
    Name: 'Hindu-Sindhi',
  },
  {
    Id: 266,
    Name: 'Hindu-Sindhi-Amil',
  },
  {
    Id: 267,
    Name: 'Hindu-Sindhi-Baibhand',
  },
  {
    Id: 268,
    Name: 'Hindu-Sindhi-Bhanusali',
  },
  {
    Id: 269,
    Name: 'Hindu-Sindhi-Bhatia',
  },
  {
    Id: 270,
    Name: 'Hindu-Sindhi-Dadu',
  },
  {
    Id: 271,
    Name: 'Hindu-Sindhi-Hyderabadi',
  },
  {
    Id: 272,
    Name: 'Hindu-Sindhi-Larai',
  },
  {
    Id: 273,
    Name: 'Hindu-Sindhi-Lohana',
  },
  {
    Id: 274,
    Name: 'Hindu-Sindhi-Rohiri',
  },
  {
    Id: 275,
    Name: 'Hindu-Sindhi-Sahiti',
  },
  {
    Id: 276,
    Name: 'Hindu-Sindhi-Sakkhar',
  },
  {
    Id: 277,
    Name: 'Hindu-Sindhi-Sehwani',
  },
  {
    Id: 278,
    Name: 'Hindu-Sindhi-Shikarpuri',
  },
  {
    Id: 279,
    Name: 'Hindu-Sindhi-Thatai',
  },
  {
    Id: 280,
    Name: 'Hindu-Sindhi-Dadu',
  },
  {
    Id: 281,
    Name: 'Hindu-Somvanshi',
  },
  {
    Id: 282,
    Name: 'Hindu-Sonar',
  },
  {
    Id: 283,
    Name: 'Hindu-Soni',
  },
  {
    Id: 284,
    Name: 'Hindu-Sourashtra',
  },
  {
    Id: 285,
    Name: 'Hindu-ST',
  },
  {
    Id: 286,
    Name: 'Hindu-Sundhi',
  },
  {
    Id: 287,
    Name: 'Hindu-Suthar',
  },
  {
    Id: 288,
    Name: 'Hindu-Swakula Sali',
  },
  {
    Id: 289,
    Name: 'Hindu-Tamboli',
  },
  {
    Id: 290,
    Name: 'Hindu-Tanti',
  },
  {
    Id: 291,
    Name: 'Hindu-Telaga',
  },
  {
    Id: 292,
    Name: 'Hindu-Teli',
  },
  {
    Id: 293,
    Name: 'Hindu-Thakkar',
  },
  {
    Id: 294,
    Name: 'Hindu-Thakur',
  },
  {
    Id: 295,
    Name: 'Hindu-Thevar/Mukkulathor',
  },
  {
    Id: 296,
    Name: 'Hindu-Thigala',
  },
  {
    Id: 297,
    Name: 'Hindu-Thiyya',
  },
  {
    Id: 298,
    Name: 'Hindu-Tili',
  },
  {
    Id: 299,
    Name: 'Hindu-Togata',
  },
  {
    Id: 300,
    Name: 'Hindu-Tribal',
  },
  {
    Id: 301,
    Name: 'Hindu-Uppara',
  },
  {
    Id: 302,
    Name: 'Hindu-Vaddera',
  },
  {
    Id: 303,
    Name: 'Hindu-Vadugan',
  },
  {
    Id: 304,
    Name: 'Hindu-Vaishnav',
  },
  {
    Id: 305,
    Name: 'Hindu-Vaishnav - Vania',
  },
  {
    Id: 306,
    Name: 'Hindu-Vaishnava',
  },
  {
    Id: 307,
    Name: 'Hindu-Vaishya',
  },
  {
    Id: 308,
    Name: 'Hindu-Vani',
  },
  {
    Id: 309,
    Name: 'Hindu-Vanika Vyshya',
  },
  {
    Id: 310,
    Name: 'Hindu-Vanjara',
  },
  {
    Id: 311,
    Name: 'Hindu-Vannar',
  },
  {
    Id: 312,
    Name: 'Hindu-Vanniyar',
  },
  {
    Id: 313,
    Name: 'Hindu-Vanniyakullak Kshatriya',
  },
  {
    Id: 314,
    Name: 'Hindu-Vanniyar',
  },
  {
    Id: 315,
    Name: 'Hindu-Vanniyar - Senguntha',
  },
  {
    Id: 316,
    Name: 'Hindu-Veera Saivam/Veerashaiva',
  },
  {
    Id: 317,
    Name: 'Hindu-Veerashaiva',
  },
  {
    Id: 318,
    Name: 'Hindu-Velama',
  },
  {
    Id: 319,
    Name: 'Hindu-Vellalar',
  },
  {
    Id: 320,
    Name: 'Hindu-Velan',
  },
  {
    Id: 321,
    Name: 'Hindu-Velluthedathu Nair',
  },
  {
    Id: 322,
    Name: 'Hindu-Vilakkoli Perumal',
  },
  {
    Id: 323,
    Name: 'Hindu-Vishwabrahmin',
  },
  {
    Id: 324,
    Name: 'Hindu-Vokaliga',
  },
  {
    Id: 325,
    Name: 'Hindu-Vysya',
  },
  {
    Id: 326,
    Name: 'Hindu-Vysya - Balija',
  },
  {
    Id: 327,
    Name: 'Hindu-Vysya - Goud',
  },
  {
    Id: 328,
    Name: 'Hindu-Vysya - Kalinga',
  },
  {
    Id: 329,
    Name: 'Hindu-Vysya - Koppala',
  },
  {
    Id: 330,
    Name: 'Hindu-Vysya - Tharakan',
  },
  {
    Id: 331,
    Name: 'Hindu-Vysya - Vaishya',
  },
  {
    Id: 332,
    Name: 'Hindu-Warrier',
  },
  {
    Id: 333,
    Name: 'Hindu-Yadav',
  },
  {
    Id: 334,
    Name: 'Hindu-Other',
  },
  {
    Id: 335,
    Name: 'Jain-Digambar',
  },
  {
    Id: 336,
    Name: 'Jain-Shwetambar',
  },
  {
    Id: 337,
    Name: 'Jain-Other',
  },
  {
    Id: 338,
    Name: 'Jain-Vania',
  },
  {
    Id: 339,
    Name: 'Jain-Vaniya',
  },
  {
    Id: 340,
    Name: 'Jain-Other',
  },
  {
    Id: 341,
    Name: 'Jain-Vania-Bania',
  },
  {
    Id: 342,
    Name: 'Jain-Other-Other',
  },
  {
    Id: 343,
    Name: 'Jain-Shwetambar-Murtipujak',
  },
  {
    Id: 344,
    Name: 'Jain-Shwetambar-Sthanakvasi',
  },
  {
    Id: 345,
    Name: 'Jain-Shwetambar-Tera Panthi',
  },
  {
    Id: 346,
    Name: 'Jain-Other-Other',
  },
  {
    Id: 347,
    Name: 'Jain-Other-Other',
  },

  {
    Id: 355,
    Name: 'Muslim-Other',
  },
  {
    Id: 356,
    Name: 'Parsi-Parsi',
  },
  {
    Id: 357,
    Name: 'Sikh-Arunthathiyar',
  },
  {
    Id: 358,
    Name: 'Sikh-Jat',
  },
  {
    Id: 359,
    Name: 'Sikh-Kamboj',
  },
  {
    Id: 360,
    Name: 'Sikh-Kesadhari',
  },
  {
    Id: 361,
    Name: 'Sikh-Khatri',
  },
  {
    Id: 362,
    Name: 'Sikh-Mazhbi',
  },
  {
    Id: 363,
    Name: 'Sikh-Ramdasia',
  },
  {
    Id: 364,
    Name: 'Sikh-Ramgharia',
  },
  {
    Id: 365,
    Name: 'Sikh-Saini',
  },
  {
    Id: 366,
    Name: 'Sikh-Other',
  },
  {
    Id: 367,
    Name: 'Buddhist',
  },
  {
    Id: 368,
    Name: 'Parsi',
  },
  {
    Id: 369,
    Name: 'Jewish',
  },
  {
    Id: 370,
    Name: 'Other',
  },
  {
    Id: 371,
    Name: 'No Religion',
  },

  {
    Id: 372,
    Name: 'Muslim-Ansari',
  },
  {
    Id: 373,
    Name: 'Muslim-Arain',
  },
  {
    Id: 374,
    Name: 'Muslim-Awan',
  },
  {
    Id: 375,
    Name: 'Muslim-Dawoodi Bohra',
  },
  {
    Id: 376,
    Name: 'Muslim-Dekkani',
  },
  {
    Id: 377,
    Name: 'Muslim-Dudekula',
  },
  {
    Id: 378,
    Name: 'Muslim-Jat',
  },
  {
    Id: 379,
    Name: 'Muslim-Khoja',
  },
  {
    Id: 380,
    Name: 'Muslim-Lebbai',
  },
  {
    Id: 381,
    Name: 'Muslim-Mapila',
  },
  {
    Id: 382,
    Name: 'Muslim-Maraicar',
  },
  {
    Id: 383,
    Name: 'Muslim-Memon',
  },
  {
    Id: 384,
    Name: 'Muslim-Mughal',
  },
  {
    Id: 385,
    Name: 'Muslim-Pathan',
  },
  {
    Id: 386,
    Name: 'Muslim-Qureshi',
  },
  {
    Id: 387,
    Name: 'Muslim-Rajput',
  },
  {
    Id: 388,
    Name: 'Muslim-Rowther',
  },
  {
    Id: 389,
    Name: 'Muslim-Shafi',
  },
  {
    Id: 390,
    Name: 'Muslim-Sheikh',
  },
  {
    Id: 391,
    Name: 'Muslim-Shia',
  },
  {
    Id: 392,
    Name: 'Muslim-Shia Bohra',
  },
  {
    Id: 393,
    Name: 'Muslim-Shia Imami Ismaili',
  },
  {
    Id: 394,
    Name: 'Muslim-Shia Ithna ashariyyah',
  },
  {
    Id: 395,
    Name: 'Muslim-Shia Zaidi',
  },
  {
    Id: 396,
    Name: 'Muslim-Siddiqui',
  },
  {
    Id: 397,
    Name: 'Muslim-Sunni',
  },
  {
    Id: 398,
    Name: 'Muslim-Sunni Ehle-Hadith',
  },
  {
    Id: 399,
    Name: 'Muslim-Sunni Hanafi',
  },
  {
    Id: 400,
    Name: 'Muslim-Sunni Hunbali',
  },
  {
    Id: 401,
    Name: 'Muslim-Sunni Maliki',
  },
  {
    Id: 402,
    Name: 'Muslim-Sunni Shafi',
  },
  {
    Id: 403,
    Name: 'Muslim-Syed',
  },
];
